import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BrowserUtils } from '@azure/msal-browser'
import { MsalGuard } from '@azure/msal-angular'
import { AuthGuard } from './core/services/auth-guard.service'
import { Permissions } from './core/enums/permissions.enum'
import { InternalPageComponent } from './internal/internal-page/internal-page.component'
import { CustomerPageComponent } from './customer/customer-page/customer-page.component'

export enum AppPaths {
  Internal = 'internal',
  Maintenance = 'maintenance',
  Customer = 'customer',
}

const routes: Routes = [
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: AppPaths.Internal,
        component: InternalPageComponent,
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [Permissions.VZO_Apps_Internal],
        },
      },
      {
        path: AppPaths.Customer,
        component: CustomerPageComponent,
        canActivate: [AuthGuard],
        data: {
          requiredPermissions: [Permissions.VZO_Apps_Customer],
        },
      },
      { path: '', redirectTo: AppPaths.Customer, pathMatch: 'full' },
      { path: '**', redirectTo: AppPaths.Customer, pathMatch: 'full' },
    ],
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
